// Spec 078 — de onde a cena vem: sessão (`/lines/:id/scene`) ou link de exibição
// (`/display/:token/scene`). Um único ponto de escolha, para a página ambiente e o LineScene
// partilharem a MESMA query (TanStack deduplica pela chave — sem fetch dobrado).
import type { UseQueryResult } from "@tanstack/react-query";
import type { LineSceneResponse } from "@/types/scene.types";
import { useDisplayScene } from "./useDisplayScene";
import { useLineScene } from "./useLineScene";

export interface SceneSource {
  query: UseQueryResult<LineSceneResponse>;
  linkInactive: boolean;
}

export function useSceneSource(lineId: string, displayToken?: string): SceneSource {
  const line = useLineScene(lineId, { enabled: !displayToken });
  const display = useDisplayScene(displayToken ?? null);
  return displayToken
    ? { query: display.query, linkInactive: display.linkInactive }
    : { query: line, linkInactive: false };
}
